import { render, staticRenderFns } from "./PageProfile.vue?vue&type=template&id=ccd47630&scoped=true&"
import script from "./PageProfile.vue?vue&type=script&lang=js&"
export * from "./PageProfile.vue?vue&type=script&lang=js&"
import style0 from "./PageProfile.vue?vue&type=style&index=0&id=ccd47630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd47630",
  null
  
)

export default component.exports